module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1aOKFG/tc-custom/9781614233541.jpg?1684245186635",
      "alt": "This image is the cover for the book Twin Cities Prohibition"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Twin Cities Prohibition\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Ferret out the haunts and habits of those who kept speakeasy doors oiled and politics crooked in the Twin Cities. If you take a tour of former blind pigs today, you will probably encounter nothing more dangerous than a life-long attraction to the 5-8 Club's Juicy Lucy Burger, but Twin Cities Prohibition will return you to a time when honest reporting like that of Walter Liggett was answered with machine gun fire. Clink glasses with notorious characters such as Kid Cann, Dapper Dan Hogan and Doc Ames, the \"Shame of Minneapolis\" in Elizabeth Johanneck's raid on this fascinating era of history.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Elizabeth Johanneck\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Beth Johanneck was born a Minnesota farmer's daughter, with seven brothers and a fabulous sister, and raised on a farm near the tiny community of Wabasso. During her childhood, she was inspired by her mother's creativity and her father's gift for storytelling. She received a bachelor's degree in business from Southwest State University in Marshall, Minnesota, and grabbed an opportunity to work for a tourism office within the central part of the Minnesota River Valley. She currently resides in the Twin Cities but hasn't forgotten her rural roots, publishing a blog called the Minnesota Country Mouse Folk Blog, where the \"hayseed\" in her writing betrays her \"city-slicker\" aspirations. She subscribes to the early to bed, early to rise philosophy, celebrating the wee hours of the morning in her big chair with a stout cup of coffee and her computer.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The History Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0